import { __read, __spreadArray } from "tslib";
import { useCallback } from 'react';
export function useMutateSettingsCallbacks(settings, setSettings) {
    var onUpsertSetting = useCallback(function (setting) {
        if (settings) {
            var settingIndex = settings.findIndex(function (val) { return val.name === setting.name; });
            var newSettings = __spreadArray([], __read(settings), false);
            if (settingIndex < 0) {
                newSettings.unshift(setting);
            }
            else {
                newSettings[settingIndex] = setting;
            }
            setSettings(newSettings);
        }
        else {
            setSettings([setting]);
        }
    }, [setSettings, settings]);
    var onDeleteSetting = useCallback(function (setting) {
        if (!settings || !settings.length) {
            return;
        }
        var settingIndex = settings.findIndex(function (val) { return val.name === setting.name; });
        if (settingIndex >= 0) {
            var clonedSettings = __spreadArray([], __read(settings), false);
            clonedSettings.splice(settingIndex, 1);
            setSettings(clonedSettings);
        }
    }, [setSettings, settings]);
    var onUpsertSettingError = useCallback(function (setting) {
        onDeleteSetting(setting);
    }, [onDeleteSetting]);
    var onDeleteSettingError = useCallback(function (setting) {
        onUpsertSetting(setting);
    }, [onUpsertSetting]);
    return {
        onUpsertSetting: onUpsertSetting,
        onDeleteSetting: onDeleteSetting,
        onUpsertSettingError: onUpsertSettingError,
        onDeleteSettingError: onDeleteSettingError,
    };
}
//# sourceMappingURL=useMutateSettingsCallbacks.js.map